import { render, staticRenderFns } from "./BarrierComponent.vue?vue&type=template&id=11bf38c0&"
import script from "./BarrierComponent.vue?vue&type=script&lang=js&"
export * from "./BarrierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports